<template>
  <el-row class="group">
    <el-col class="title" :span="2">{{title}}:</el-col>
    <el-col class="body" :span="22">
      <el-link
        v-for="(i,index) in items"
        :class="currentSelectedCode === i.code ? 'link-active':''"
        @click="handleClick(index)"
        :underline="false"
        :key="index">
        {{i.value}}
      </el-link>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'group-row',
    props: {
      title: String,
      items: Array,
      selectedCode: String
    },
    data() {
      return {
        currentSelectedCode: this.selectedCode,
        selectedItem: {}
      }
    },
    methods: {
      handleClick(index) {
        this.currentSelectedCode = this.items[index].code
        this.$emit('click', this.items[index])
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../style/variables.scss';
  .group {
    margin-top: 10px;
    padding: 0 10px;
  }
  .title {
    color: #999;
    margin: 4px 0;
  }
  .body >>> .el-link {
    margin: 4px 0 4px 40px;
    font-size: 16px;
  }
  .body >>> .el-link--inner {
    text-decoration: none;
    &:hover {
      color: $theme-yellow;
    }
  }
  .body .link-active {
    color: $theme-yellow;
  }
</style>



// WEBPACK FOOTER //
// src/components/group-row.vue